module.exports = __webpack_public_path__ + "img/talk_ico.f9daee2d.png";